<div class="container">
  <section id="home">
    <app-dashboard></app-dashboard>
  </section>
  <section id="about">
   <app-about></app-about>
  </section>
  <section id="skills">
    <app-skills></app-skills>
  </section>
</div>
